import axios from "axios";
import { useLocalObservable } from "mobx-react-lite";
import { toJS } from "mobx";
import { listBetType } from "../assets/constants";

// ref: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/typeof
// object and array is same
// object and null is same
export const dataType = (data = null) => {
	const dataList = [
		"number",
		"bigint",
		"string",
		"boolean",
		"symbol",
		"undefined",
		"function",
	];

	if (data === null) return "null";

	const type = typeof data;

	if (dataList.indexOf(type) > -1) {
		if (type !== "string") return type;
	}

	if (Array.isArray(data)) return "array";

	if (isJson(data)) {
		if (isNumber(data)) return "string number";
		return "json";
	}

	if (type === "object") return "object";

	if (type === "string") return "string";

	return "not on if else";
};

export const isJson = (str = null) => {
	try {
		JSON.parse(str);
	} catch (e) {
		return false;
	}
	return true;
};

// ref: https://stackoverflow.com/questions/1303646/check-whether-variable-is-number-or-string-in-javascript
export const isNumber = (n) => {
	return !isNaN(parseFloat(n)) && !isNaN(n - 0);
};

export const sureObj = (str = null) => {
	while (isJson(str)) {
		str = JSON.parse(str);
	}
	return str;
};

export const cleanData = (data = {}) => {
	data = sureObj(data);
	if (typeof data === "object") data = JSON.stringify(data, null, 4);
	return data;
};

export const pre = (data = {}, title = "") => {
	if (isNumber(data)) return data;

	title = title.trim();

	const type = dataType(data);
	data = cleanData(data);

	return (
		<>
			{title !== "" ? <h2>{title}</h2> : null}
			<p>Data Type: {type}</p>
			{/* Data Type: {typeof data} */}
			<pre>{data}</pre>
		</>
	);
};

// https://stackoverflow.com/questions/8511281/check-if-a-value-is-an-object-in-javascript
export const isObj = (obj = {}) => {
	return typeof obj === "object" && obj !== null;
};

export const urlTrim = (str = "") => {
	return str.replace(/^\/+|\/+$/g, "");
};

export const axiosReq = (
	url,
	data = {},
	token = "",
	method = "POST",
	preUrl = process.env.REACT_APP_BASE_URL_API
) => {
	return new Promise((resolve, reject) => {
		let p = {};

		p = {
			headers: {
				fc: process.env.REACT_APP_API_KEY,
			},
		};

		if (Object.keys(data).length > 0)
			p = {
				data: data,
				...p,
			};

		const url2 = urlTrim(preUrl) + "/" + urlTrim(url);

		axios({
			url: url2,
			method: method,
			...p,
		}).then(
			(res) => {
				res = res.data;
				resolve(res);
			},
			(err) => reject(err)
		);
	});
};

export function axiosReqImg(
	url,
	name,
	data = {},
	token = "",
	method = "POST",
	preUrl = process.env.REACT_APP_BASE_URL_API
) {
	return new Promise((resolve, reject) => {
		if (token !== "") token = token.trim();
		let p = {
			headers: {
				"content-type": "multipart/form-data",
				Accept: "application/json",
			},
		};

		if (token !== "")
			p.headers = {
				...p.headers,
				Authorization: "Bearer " + token,
			};

		const fd = new FormData();

		let item = null;
		for (item of data) {
			fd.append(name, item, item.name);
		}

		p = {
			data: fd,
			...p,
		};

		const url2 = urlTrim(preUrl) + "/" + urlTrim(url);

		axios({
			url: url2,
			method: method,
			...p,
		}).then(
			(res) => {
				res = res.data;
				resolve(res);
			},
			(err) => reject(err)
		);
	});
}

export const datePhpToJs = (dat = null) => {
	if (dat === null) return null;

	if (dat.indexOf(" ") > -1) {
		let dat_arr = dat.split(" ");
		dat = dat_arr[0];
	}

	let d = dat.split("-");
	return new Date(parseInt(d[0]), parseInt(d[1]) - 1, parseInt(d[2]));
};

export const MonthsLong = [
	"January",
	"February",
	"March",
	"April",
	"May",
	"June",
	"July",
	"August",
	"September",
	"October",
	"November",
	"December",
];

export const MonthsShort = [
	"Jan",
	"Feb",
	"Mar",
	"Apr",
	"May",
	"Jun",
	"Jul",
	"Aug",
	"Sep",
	"Oct",
	"Nov",
	"Dec",
];

export const WeeksLong = [
	"Sunday",
	"Monday",
	"Tuesday",
	"Wednesday",
	"Thursday",
	"Friday",
	"Saturday",
];

export const WeeksShort = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export const mdf = (n) => {
	var n1 = parseInt(n);
	if (10 > n1) return "0" + n1;
	return n1;
};

// https://stackoverflow.com/questions/6117814/get-week-of-year-in-javascript-like-in-php
// function getWeekNumber(d) {
// 	// Copy date so don't modify original
// 	d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
// 	// Set to nearest Thursday: current date + 4 - current day number
// 	// Make Sunday's day number 7
// 	d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
// 	// Get first day of year
// 	var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
// 	// Calculate full weeks to nearest Thursday
// 	var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
// 	// Return array of year and week number
// 	return [d.getUTCFullYear(), weekNo];
// }

export const datePhpFormat = (dat = null) => {
	let dateJs = datePhpToJs(dat);
	// console.log("dat", dat);
	// console.log("dateJs", dateJs);

	let month = MonthsShort[dateJs.getMonth()];
	let day = dateJs.getDate();
	let year = dateJs.getFullYear();

	let week = WeeksShort[dateJs.getDay()];

	let formatDate = week + ", " + day + " " + month + " " + year;
	return formatDate;
};

export const datePhpFormat2 = (dat = null) => {
	// let dateJs = datePhpToJs(dat);
	let dateJs = new Date(dat);

	// console.log("dat", dat);
	// console.log("dateJs", dateJs);

	let month = MonthsShort[dateJs.getMonth()];
	let day = dateJs.getDate();
	let year = dateJs.getFullYear();

	let week = WeeksShort[dateJs.getDay()];

	let formatDate = week + ", " + day + " " + month + " " + year;
	return formatDate;
};

export const dateTimePhpFormat = (dat = null) => {
	let datArr = dat.split(" ");

	let dateJs = datePhpToJs(datArr[0]);
	let month = MonthsShort[dateJs.getMonth()];
	let day = dateJs.getDate();
	let year = dateJs.getFullYear();

	let week = WeeksShort[dateJs.getDay()];

	//
	let timeArr = datArr[1].split(":");
	let hour = parseInt(timeArr[0]);
	let min = parseInt(timeArr[1]);

	let a = "am";
	if (hour > 11) {
		a = "pm";
		if (hour > 12) hour -= 12;
	} else if (hour === 0) {
		a = "am";
		hour = "12";
	}

	let formatDate =
		week +
		", " +
		day +
		" " +
		month +
		" " +
		year +
		", " +
		hour +
		":" +
		mdf(min) +
		a;
	return formatDate;
};

// https://stackoverflow.com/questions/6736476/how-to-turn-nan-from-parseint-into-0-for-an-empty-string
export const parseInt2 = (v = 0, def = 0) => {
	return parseInt(v) || def;
};

// eslint-disable-next-line
const onlyUnique = (value, index, self) => {
	return self.indexOf(value) === index;
};

// eslint-disable-next-line
const array_unique = (arr = []) => {
	return arr.filter(onlyUnique);
};

// https://stackoverflow.com/questions/9960908/permutations-in-javascript
export const permuteCount = (arr = []) => {
	//
	let arr2 = [];
	arr.forEach((e) => {
		arr2.push(parseInt(e));
	});
	arr = arr2;

	//
	var permArr = [],
		usedChars = [];

	function permute(input) {
		var i, ch;
		for (i = 0; i < input.length; i++) {
			ch = input.splice(i, 1)[0];
			usedChars.push(ch);
			if (input.length === 0) {
				permArr.push(usedChars.slice());
			}
			permute(input);
			input.splice(i, 0, ch);
			usedChars.pop();
		}
		return permArr;
	}

	while (arr.length < 4) {
		arr.push(0);
	}

	permute(arr);

	let tmpArr = [];
	permArr.map((e) => {
		let x = JSON.stringify(e);

		if (tmpArr.indexOf(x) < 0) {
			tmpArr.push(x);
		}
		return undefined;
	});

	return tmpArr.length;
};

// https://stackoverflow.com/questions/9960908/permutations-in-javascript
// export const permuteCount = (permutation) => {
// 	var length = permutation.length,
// 		result = [permutation.slice()],
// 		c = new Array(length).fill(0),
// 		i = 1,
// 		k,
// 		p;

// 	while (i < length) {
// 		if (c[i] < i) {
// 			k = i % 2 && c[i];
// 			p = permutation[i];
// 			permutation[i] = permutation[k];
// 			permutation[k] = p;
// 			++c[i];
// 			i = 1;
// 			result.push(permutation.slice());
// 		} else {
// 			c[i] = 0;
// 			++i;
// 		}
// 	}
// 	return result.length;
// };

// https://www.codegrepper.com/code-examples/javascript/number+permutation+javascript
// export const permuteCount = (arr2) => {
// 	const permute = (arr, perms = [], len = arr.length) => {
// 		if (len === 1) perms.push(arr.slice(0));

// 		for (let i = 0; i < len; i++) {
// 			permute(arr, perms, len - 1);

// 			len % 2 // parity dependent adjacent elements swap
// 				? ([arr[0], arr[len - 1]] = [arr[len - 1], arr[0]])
// 				: ([arr[i], arr[len - 1]] = [arr[len - 1], arr[i]]);
// 		}

// 		return perms;
// 	};

// 	let d = [...permute(arr2)];
// 	return d.length;
// };

export const currentDate = (time_zone = "Asia/Singapore") => {
	time_zone = time_zone.trim();
	if (time_zone === "") time_zone = "Asia/Singapore";

	let d = new Date().toLocaleString("en-SG", { timeZone: time_zone }); // output: "28/01/2020, 12:09:41 pm"

	let d_arr = d.split(", ");
	let d_date = d_arr[0];
	d_date = d_date.split("/");

	let d_time = d_arr[1];
	d_time = d_time.split(" ");

	let d_time1 = d_time[0];
	d_time1 = d_time1.split(":");

	let d_time2 = d_time[1];
	d_time2 = d_time2.trim().toString().toLowerCase();

	let h = parseInt(d_time1[0]);
	let i = parseInt(d_time1[1]);
	let s = parseInt(d_time1[2]);

	let ampm = d_time2;

	if (ampm === "am" && h === 12) {
		h = 0;
	}
	if (ampm === "pm" && h < 12) {
		h += 12;
	}

	return new Date(d_date[2], parseInt(d_date[1]) - 1, d_date[0], h, i, s);
};

export const php2js = (d) => {
	let e = null;
	let h = 0;
	let i = 0;
	let s = 0;
	d = String(d);
	if (d.indexOf(" ") > -1) {
		e = d.split(" ");
		let f = e[1].split(":");
		h = f[0];
		i = f[1];
		s = f[2];
		e = e[0];
	} else {
		e = d;
	}
	let g = e.split("-");
	return new Date(
		parseInt(g[0]),
		parseInt(g[1]) - 1,
		parseInt(g[2]),
		parseInt(h),
		parseInt(i),
		parseInt(s)
	);
};

/**
 * ref: https://gist.github.com/micah1701/4120120
 * Return a formated string from a date Object mimicking PHP's date() functionality
 *
 * format  string  "Y-m-d H:i:s" or similar PHP-style date format string
 * date    mixed   Date Object, Datestring, or milliseconds
 *
 */
export function dateFormat(format, date) {
	if (!date || date === "") {
		date = new Date();
	} else if (typeof date !== "object") {
		// date = new Date(date.replace(/-/g, "/")); // attempt to convert string to date object
		date = php2js(date);
	}

	if (!(date instanceof Date)) date = new Date(date);

	var string = "",
		mo = date.getMonth(), // month (0-11)
		m1 = mo + 1, // month (1-12)
		dow = date.getDay(), // day of week (0-6)
		d = date.getDate(), // day of the month (1-31)
		y = date.getFullYear(), // 1999 or 2003
		h = date.getHours(), // hour (0-23)
		mi = date.getMinutes(), // minute (0-59)
		s = date.getSeconds(); // seconds (0-59)

	for (var i = 0, len = format.length; i < len; i++) {
		switch (format[i]) {
			case "j": // Day of the month without leading zeros  (1 to 31)
				string += d;
				break;

			case "d": // Day of the month, 2 digits with leading zeros (01 to 31)
				string += d < 10 ? "0" + d : d;
				break;

			case "l": // (lowercase 'L') A full textual representation of the day of the week
				var days = [
					"Sunday",
					"Monday",
					"Tuesday",
					"Wednesday",
					"Thursday",
					"Friday",
					"Saturday",
				];
				string += days[dow];
				break;

			case "w": // Numeric representation of the day of the week (0=Sunday,1=Monday,...6=Saturday)
				string += dow;
				break;

			case "D": // A textual representation of a day, three letters
				days = ["Sun", "Mon", "Tue", "Wed", "Thr", "Fri", "Sat"];
				string += days[dow];
				break;

			case "m": // Numeric representation of a month, with leading zeros (01 to 12)
				string += m1 < 10 ? "0" + m1 : m1;
				break;

			case "n": // Numeric representation of a month, without leading zeros (1 to 12)
				string += m1;
				break;

			case "F": // A full textual representation of a month, such as January or March
				var months = [
					"January",
					"February",
					"March",
					"April",
					"May",
					"June",
					"July",
					"August",
					"September",
					"October",
					"November",
					"December",
				];
				string += months[mo];
				break;

			case "M": // A short textual representation of a month, three letters (Jan - Dec)
				months = [
					"Jan",
					"Feb",
					"Mar",
					"Apr",
					"May",
					"Jun",
					"Jul",
					"Aug",
					"Sep",
					"Oct",
					"Nov",
					"Dec",
				];
				string += months[mo];
				break;

			case "Y": // A full numeric representation of a year, 4 digits (1999 OR 2003)
				string += y;
				break;

			case "y": // A two digit representation of a year (99 OR 03)
				string += y.toString().slice(-2);
				break;

			case "H": // 24-hour format of an hour with leading zeros (00 to 23)
				string += h < 10 ? "0" + h : h;
				break;

			case "g": // 12-hour format of an hour without leading zeros (1 to 12)
				var hour = h === 0 ? 12 : h;
				string += hour > 12 ? hour - 12 : hour;
				break;

			case "h": // 12-hour format of an hour with leading zeros (01 to 12)
				hour = h === 0 ? 12 : h;
				hour = hour > 12 ? hour - 12 : hour;
				string += hour < 10 ? "0" + hour : hour;
				break;

			case "a": // Lowercase Ante meridiem and Post meridiem (am or pm)
				string += h < 12 ? "am" : "pm";
				break;

			case "A": // Lowercase Ante meridiem and Post meridiem (am or pm)
				string += h < 12 ? "AM" : "PM";
				break;

			case "i": // Minutes with leading zeros (00 to 59)
				string += mi < 10 ? "0" + mi : mi;
				break;

			case "s": // Seconds, with leading zeros (00 to 59)
				string += s < 10 ? "0" + s : s;
				break;

			case "c": // ISO 8601 date (eg: 2012-11-20T18:05:54.944Z)
				string += date.toISOString();
				break;

			default:
				string += format[i];
		}
	}

	return string;
}

export const sort = (arr) => {
	return arr.sort((a, b) => {
		if (a === "K") {
			return -1;
		}

		// if (a === "" || b !== "") return 0;
		// else if (a !== "" || b === "") return 0;
		// else
		return Number(a) < Number(b) ? -1 : Number(a) > Number(b) ? 1 : 0;
	});
};

export const cl = (...args) => {
	return console.log(...args);
};

export const Fetch2 = (url, v2 = {}) => {
	const v = useLocalObservable(() => ({
		init: true,
		loading: false,
		disable: false,

		ok: false,
		status: 0,
		statusText: "",
		request: {},
		response: {},
	}));

	// base url
	// prettier-ignore
	let baseUrl =
		(v2.baseUrl !== "" && v2.baseUrl !== undefined)
			? v2.baseUrl
			: process.env.REACT_APP_BASE_URL_API;

	// defaults and set
	let method = v2.method || process.env.REACT_APP_DEFAULT_FETCH_METHOD;
	let data = v2.data || {};

	// prepare url
	let url2 = "";
	if (baseUrl !== "") {
		url2 += urlTrim(baseUrl) + "/";
	}
	url2 += urlTrim(url);

	// prepare header
	let headers = {
		fc: process.env.REACT_APP_API_KEY,
	};

	// image
	let image = v2.image || false;

	// prepare params
	let params = {
		method: image ? "POST" : method,
	};
	if (JSON.stringify(headers) !== "{}") {
		params = { ...params, headers: { ...headers } };
	}
	if (JSON.stringify(data) !== "{}") {
		if (!image) params = { ...params, data: { ...data } };
		else {
			const formData = new FormData();
			Object.entries(data).forEach((e) => {
				formData.append(e[0], e[1]);
			});
			params = { ...params, data: formData };
		}
	}
	//
	let delay = v2.delay || 0;

	const handleTrigger = async (params2 = {}) => {
		params = { ...params, data: { ...params.data, ...params2 } };
		v.init = false;
		v.loading = true;

		v.ok = false;
		v.status = 0;
		v.statusText = "";
		v.request = {};
		v.response = {};

		if (!v.disable) {
			v.disable = true;

			if (v2.callbackInit) {
				v2.callbackInit();
			}

			await axios({
				url: url2,
				...params,
			}).then(
				(res) => {
					v.ok = true;
					v.status = res.status;
					v.statusText = res.statusText;

					v.request = {
						url: res.config.url,
						method: res.config.method,
						data: res.config.data,
						header: res.headers,
					};
					v.response = res.data;
				},
				(err) => {
					// alert(JSON.stringify(err));
					v.disable = false;
					if (err.response) {
						v.status = err.response.status;
						if (v.status === 404) {
							v.statusText = "request not found";
						} else {
							v.statusText = err.response.statusText;
						}
						// console.log(toJS(v));

						v.request = {
							url: err.response.config.url,
							method: err.response.config.method,
							header: err.response.config.headers,
							data: err.response.config.data,
						};

						v.response = {
							exception: err.response.data.exception,
							file: err.response.data.file,
							line: err.response.data.line,
							message: err.response.data.message,
						};

						reportErrorApi({
							data: {
								request: toJS(v.request),
								response: toJS(v.response),
							},
						});
					} else {
						v.statusText = "No Internet";
					}
				}
			);

			setTimeout(() => {
				v.loading = false;
				v.disable = false;

				if (v2.callback) {
					v2.callback(toJS(v));
				}
			}, delay);
		}

		return toJS(v);
	};

	let d = { ...toJS(v), handleTrigger: handleTrigger };
	return { ...d, all: { ...d } };
};

export const reportErrorApi = ({
	baseUrl = undefined,
	url = undefined,
	method = undefined,
	data = undefined,
}) => {
	baseUrl = baseUrl || baseUrl === "" ? "" : process.env.REACT_APP_BASE_URL_API;
	method = method || process.env.REACT_APP_DEFAULT_FETCH_METHOD;
	url = url || process.env.REACT_REPORT_API;
	data = data || {};

	if (data.response.exception !== undefined) {
		if (data.response.exception.indexOf("NotFoundHttpException") > -1) {
			return null;
		}
	}

	// prepare url
	let url2 = "";
	if (baseUrl !== "") {
		url2 += urlTrim(baseUrl) + "/";
	}
	url2 += urlTrim(url);

	axios({
		url: url2,
		data: { ...data },
	})
		.then((res) => {
			cl("reportErrorApi, res", res);
		})
		.then((err) => {
			cl("reportErrorApi, err", err);
		});
};

export const computation4d = (fourDPlaceBet, draw) => {
	// let tempDrawDate = [];

	// fourDPlaceBet.drawWeeks.map((f) => {
	//   if (f === "6 Draws") {
	//     draw.map((g) => {
	//       tempDrawDate.push({
	//         date: datePhpFormat(g.draw_date) + ", 6:30pm",
	//         no: g.draw_no,
	//       });
	//       return undefined;
	//     });
	//   } else {
	//     let ctr = 0;
	//     draw.map((g) => {
	//       ctr++;
	//       if (g.draw_week.indexOf(f) > -1 && ctr < 4) {
	//         tempDrawDate.push({
	//           date: datePhpFormat(g.draw_date) + ", 6:30pm",
	//           no: g.draw_no,
	//         });
	//       }
	//       return undefined;
	//     });
	//   }
	//   return undefined;
	// });

	// let total2 = fourDPlaceBet.total;

	delete fourDPlaceBet.total;

	return {
		placeBet: fourDPlaceBet,
		// date: tempDrawDate,
		// total: total2,
	};
};

export const compute4dTotal = (fourDCompute, settings) => {
	let total = 0;
	fourDCompute.forEach((fourDComputeEach) => {
		total += parseFloat(compute4dTotalEach(fourDComputeEach, settings));
	});
	return total;
};

export const compute4dTotalEach = (fourDComputeEach, settings) => {
	let total = 0;
	let f = fourDComputeEach.placeBet;

	let datesLength = f.drawWeeks.length;
	if (f.drawWeeks[0] === "6 Draws") datesLength = 6;

	f.board.forEach((eachBoard) =>
		// prettier-ignore
		{
      if(f.betType === "System Entry")
        total += 
          (
            (
              eachBoard.big * settings.bet_per_big 
            ) +
            (
              eachBoard.small * settings.bet_per_small
            )
          ) *
          datesLength * 
          permuteCount(eachBoard.betSlip);
      else if(f.betType === "4D Roll")
        total += 
        (
          (
            eachBoard.big * settings.bet_per_big 
          ) +
          (
            eachBoard.small * settings.bet_per_small
          )
        ) *
        datesLength * 
        10;
      else
        total += 
        (
          (
            eachBoard.big * settings.bet_per_big 
          ) +
          (
            eachBoard.small * settings.bet_per_small
          )
        ) *
        datesLength;
    }
	);

	return total.toFixed(2);
};

export const computationToto = (totoPlaceBetFinal) => {
	let total2 = 0;
	let newTotoPlaceBetFinal = [];
	totoPlaceBetFinal.map((a, aI) => {
		let total = 0;
		a.placeBet.eachPlaceBet.map((b) =>
			b.map((c, cI) => {
				let e = listBetType.filter((d) => {
					return d.title === a.betType;
				});

				let times = 1;
				if (a.drawWeeks === "2 Draws") times = 2;
				else if (a.drawWeeks === "4 Draws") times = 4;

				total += e[0].price * times;
				return null;
			})
		);

		total2 += total;
		newTotoPlaceBetFinal.push({
			...a,
			total: total,
		});
		return null;
	});
	return {
		compute: newTotoPlaceBetFinal,
		total: total2,
	};
};

export const computeTotoTotal = (totoPlaceBetFinal, totoSet) => {
	let total = 0;

	let totoSet2 = {};
	totoSet.forEach((a) => {
		totoSet2[a.name] = a.price;
	});

	totoPlaceBetFinal.forEach((a) => {
		let multi = 1;
		if (a.drawWeeks === "2 Draws") multi = 2;
		else if (a.drawWeeks === "4 Draws") multi = 4;

		total += totoSet2[a.betType] * a.placeBet.length * multi;
	});

	return total;
};

export const capitalize = (str) => {
	return str.charAt(0).toUpperCase() + str.slice(1);
};

export const datePerTime = (d) => {
	let d2 = [
		"2023-08-04",
		"2023-12-21",
		"2024-01-05",
		"2024-08-02",
		"2025-01-03",
		"2025-02-07",
		"2025-04-28",
		"2025-06-19",
		"2025-07-17",
		"2025-07-31",
		"2025-08-08",
		"2025-08-28",
		"2025-09-29",
		"2025-10-23",
	];
	return datePhpFormat(d) + (d2.indexOf(d) > -1 ? ", 9:30pm" : ", 6:30pm");
};

function pad(num, size = 2) {
	num = num.toString();
	while (num.length < size) num = "0" + num;
	return num;
}

export const sec = (t) => {
	let s = 0;
	if (localStorage.getItem("time_login_ls")) {
		s = localStorage.getItem("time_login_ls");
	}

	// console.log(s);
	// console.log(t);

	s = s - t;
	if (s < 0) s = 0;

	s = s / 1000;

	const m = pad(Math.round(s % 60), 2);
	const remain_m = Math.floor(s / 60);

	let r = remain_m + ":" + m;

	if (r === "0:00") return "";

	return " " + r;
};
